import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(()=>({
  textarea: {
    fontWeight: 400,
    fontSize: 14,
    fontFamily: 'Roboto',
    color:'#545964',
    border: '1px solid #AAA2AA',
    padding: '6px 16px',
    boxSizing: 'border-box',
    '&::placeholder': {
      fontWeight: 400,
      fontSize: 14,
      fontFamily: 'Roboto',
      color: '#80848D',
      opacity: 1, // Firefox lowers the opacity of the placeholder text
    },
  }
}));

export default useStyles;
